import { toast } from "react-toastify";

import i18n from "i18next";

import { ReactComponent as IconError } from "../assets/ic-error.svg";
import { ReactComponent as IconInfo } from "../assets/ic-toast-info.svg";
import { ReactComponent as IconSuccessCheckmark } from "../assets/ic-success-checkmark.svg";

const options = {
  hideProgressBar: true,
  position: "top-center",
  theme: "dark",
  pauseOnHover: false,
};

export class ToasterService {
  success(message) {
    toast.success(message, { ...options, icon: <IconSuccessCheckmark /> });
  }

  successTranslated(key, namespace) {
    toast.success(i18n.t(`${namespace}:${key}`), {
      ...options,
      icon: <IconSuccessCheckmark />,
    });
  }

  error(message) {
    toast.error(message, { ...options, icon: <IconError /> });
  }

  errorTranslated(message) {
    // check if the message is a key in the errors namespace
    const exists = i18n.exists(`errors:${message}`);
    // if it exists, translate it
    this.error(exists ? i18n.t(`errors:${message}`) : message);
  }

  info(message, className = "") {
    toast.info(message, {
      ...options,
      className,
      icon: <IconInfo />,
    });
  }

  infoTranslated(message, namespace) {
    // check if the message is a key in the errors namespace
    const exists = i18n.exists(`${namespace}:${message}`);
    // if it exists, translate it
    this.info(exists ? i18n.t(`${namespace}:${message}`) : message);
  }

  clearAll() {
    toast.dismiss();
  }
}

ToasterService.$displayName = "ToasterService";

export default new ToasterService();
